import * as taskName from './task-name';
import {createUIDefinition} from '../default-task-definition';
import * as processUI from '../../process-ui';
import {selectProcessContext} from '../../../state/instance-detail/selector';
import taskValidator from './check-treatability-validator';

export default createUIDefinition({
    taskName: taskName.CHECK_TREATABILITY_AFTER_CLINIC,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.REQUEST_MEDICAL_EVALUATION,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.CANNOT_BE_TREATED_REASON_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.CUSTOMER_XRAY_FILE_UPLOAD,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator,
});




// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/check-treatability.js